import RecurringOrderDetail from './RecurringOrderDetail.styled';

export default RecurringOrderDetail;
